// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/common/logo-large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/common/logo-athena.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/dashboard/profile-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-layout-ribbon {
  height: 60px;
  padding: 5px 18px 5px 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout-ribbon-logos {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dashboard-layout-ribbon-logo {
  width: 126px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: none;
  background-position: center;
  background-size: cover;
}

.dashboard-layout-ribbon-logo-athena {
  width: 126px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.dashboard-layout-ribbon-profile-details {
  display: flex;
  gap: 12px;
}

.dashboard-layout-profile-image {
  width: 44px;
  height: 44px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover !important;
  background-position: center;
  border-radius: 44px;
}

.dashboard-layout-profile-image:hover {
  cursor: pointer;
}

.dashboard-layout-profile-name {
  width: auto;
  font-weight: 600;
  margin: auto 0px;
}

.dashboard-layout-profile-name:hover {
  cursor: pointer;
}

.dashboard-layout-profile-arrow {
  font-size: 20px;
  text-align: center;
  line-height: 44px;
}

.dashboard-layout-profile-arrow:hover {
  cursor: pointer;
}

.dashboard-layout-profile-category {
  border-radius: 8px;
  font-weight: 700;
  padding: 4px 12px;
  text-align: center;
  margin: auto 0px;
}

.dashboard-layout-profile-category:hover {
  cursor: pointer;
}

.dashboard-layout-profile-category::first-letter {
  text-transform: uppercase;
}

.dashboard-layout-profile-category.Platinum {
  background-image: linear-gradient(90deg, #353535 0%, #6b6962 100%);
  color: white;
}

.dashboard-layout-profile-category.Gold {
  background-image: linear-gradient(90deg, #d7980a 0%, #fcc201 100%);
}

.dashboard-layout-profile-category.Silver {
  background-image: linear-gradient(90deg, #062360 0%, #2775ca 100%);
  color: white;
}

.dashboard-layout-profile-category.Free {
  background-image: linear-gradient(90deg, #003d3d 0%, #009898 100%);
  color: white;
}

.dashboard-layout-content {
  display: flex;
  height: calc(100vh - 96px);
}

.dashboard-layout-sidemenu {
  width: 215px;
  padding: 24px 20px 0px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* .dashboard-layout-sidemenu-portfolio {
    width: 183px;
    height: 108px;
    border-radius: 11.6px;
    background-color: var(--primary-color-b);
    padding: 12px 16px 12px 16px;
    color: var(--primary-bg-color);
  }
  
  .dashboard-layout-sidemenu-portfolio-label {
    font-weight: 500;
  }
  
  .dashboard-layout-sidemenu-portfolio-price {
    font-weight: 700;
  }
  
  .dashboard-layout-sidemenu-portfolio-turnover {
    display: flex;
    gap: 4px;
    color: var(--semantic-success-color);
    font-weight: 700;
  }
  
  .dashboard-layout-sidemenu-portfolio-turnover-arrow {
    font-size: 24px;
    line-height: 40px;
  } */

.dashboard-layout-sidemenu-item {
  width: 183px;
  background-color: var(--other-shade-c-2);
  padding: 18px 16px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
}

.selected-item {
  background-color: var(--secondary-color-b);
  color: var(--primary-bg-color);
}

.dashboard-layout-sidemenu-item-context {
  display: flex;
  gap: 12px;
  align-items: center;
}

.dashboard-layout-sidemenu-item-icon {
  width: 24px;
  height: 24px;
  font-size: 24px;
}

.dashboard-layout-sidemenu-item-label {
  line-height: 21px;
  font-weight: 600;
  font-size: 14px;
}

.dashboard-layout-dropdown-backdrop {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.dashboard-layout-dropdown {
  position: absolute;
  right: 150px;
  top: calc(59px + 18px);
  background-color: var(--primary-bg-color);
  border-radius: 12px;
  box-shadow: 4px 16px 64px 0px rgba(6, 35, 96, 0.2);
  z-index: 2;
  overflow: hidden;
}

.dashboard-layout-dropdown-item {
  padding: 12px;
  cursor: pointer;
  width: 201px;
}

.dashboard-layout-dropdown-item.account {
  box-shadow: inset 0px -2px 0px var(--neutral-color-a-0-5);
}

.dashboard-layout-dropdown-item.logout {
  font-weight: 600;
  color: var(--semantic-error-color);
}

.dashboard-layout-dropdown-item:active {
  background-color: var(--neutral-color-a-0-5);
}

.checkbox {
  opacity: 0;
  position: absolute;
}

.checkbox-label {
  background-color: #7c7c7c;
  width: 40px;
  height: 18px;
  border-radius: 50px;
  position: relative;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fa-moon {
  color: #f1c40f;
}

.fa-sun {
  color: #f39c12;
}

.checkbox-label .ball {
  background-color: #fff;
  width: 22px;
  height: 22px;
  position: absolute;
  left: 2px;
  top: 3px;
  border-radius: 50%;
  transition: transform 0.2s linear;
}

.checkbox:checked+.checkbox-label .ball {
  transform: translateX(24px);
}

.checkbox-container {
  display: flex;
  justify-content: center;
  height: 100%;
  padding-top: 10px;
}

.home-page {
  overflow: auto;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
  margin-left: 10px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #000000;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

/* Responsive styles for TV Chart page */
@media (max-width: 1310px) {
  .dashboard-layout-ribbon-logo {
    width: 100px;
    height: 30px;
  }
  
  .dashboard-layout-ribbon-logo-athena {
    width: 100px;
    height: 30px;
  }
}

@media (max-width: 768px) {
  .dashboard-layout-ribbon {
    padding: 5px 16px;
    flex-wrap: wrap;
    height: auto;
    min-height: 60px;
  }

  .dashboard-layout-ribbon-logo {
    width: 80px;
    height: 25px;
  }
  
  .dashboard-layout-ribbon-logo-athena {
    width: 80px;
    height: 25px;
  }

  .dashboard-layout-ribbon-logos {
    gap: 8px;
  }

  .dashboard-layout-ribbon-profile-details {
    gap: 8px;
    flex-wrap: wrap;
  }

  .dashboard-layout-profile-image {
    width: 36px;
    height: 36px;
  }

  .dashboard-layout-profile-name {
    font-size: 14px;
  }

  .dashboard-layout-profile-category {
    font-size: 10px;
    padding: 3px 6px;
  }
}

@media (max-width: 480px) {
  .dashboard-layout-ribbon {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    height: auto;
    padding: 12px 16px;
  }

  .dashboard-layout-ribbon-logo {
    width: 70px;
    height: 20px;
  }
  
  .dashboard-layout-ribbon-logo-athena {
    width: 70px;
    height: 20px;
  }

  .dashboard-layout-ribbon-logos {
    gap: 6px;
  }

  .dashboard-layout-ribbon-profile-details {
    width: 100%;
    justify-content: space-between;
    gap: 6px;
  }

  .dashboard-layout-profile-image {
    width: 32px;
    height: 32px;
  }

  .dashboard-layout-profile-name {
    font-size: 12px;
    flex: 1 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dashboard-layout-profile-category {
    font-size: 9px;
    padding: 2px 4px;
    min-width: -moz-fit-content;
    min-width: fit-content;
  }

  .checkbox-container {
    padding-top: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TVChart/TVChart.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yDAAwD;EACxD,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yDAAyD;EACzD,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAAiE;EACjE,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kEAAkE;EAClE,YAAY;AACd;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;EAClE,YAAY;AACd;;AAEA;EACE,kEAAkE;EAClE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2BK;;AAEL;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,yCAAyC;EACzC,mBAAmB;EACnB,kDAAkD;EAClD,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,2BAAsB;IAAtB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".dashboard-layout-ribbon {\n  height: 60px;\n  padding: 5px 18px 5px 76px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-layout-ribbon-logos {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dashboard-layout-ribbon-logo {\n  width: 126px;\n  height: 40px;\n  background-image: url(/src/assets/common/logo-large.svg);\n  background-repeat: none;\n  background-position: center;\n  background-size: cover;\n}\n\n.dashboard-layout-ribbon-logo-athena {\n  width: 126px;\n  height: 40px;\n  background-image: url(/src/assets/common/logo-athena.png);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.dashboard-layout-ribbon-profile-details {\n  display: flex;\n  gap: 12px;\n}\n\n.dashboard-layout-profile-image {\n  width: 44px;\n  height: 44px;\n  background-image: url('../../assets/dashboard/profile-image.png');\n  background-repeat: no-repeat;\n  background-size: cover !important;\n  background-position: center;\n  border-radius: 44px;\n}\n\n.dashboard-layout-profile-image:hover {\n  cursor: pointer;\n}\n\n.dashboard-layout-profile-name {\n  width: auto;\n  font-weight: 600;\n  margin: auto 0px;\n}\n\n.dashboard-layout-profile-name:hover {\n  cursor: pointer;\n}\n\n.dashboard-layout-profile-arrow {\n  font-size: 20px;\n  text-align: center;\n  line-height: 44px;\n}\n\n.dashboard-layout-profile-arrow:hover {\n  cursor: pointer;\n}\n\n.dashboard-layout-profile-category {\n  border-radius: 8px;\n  font-weight: 700;\n  padding: 4px 12px;\n  text-align: center;\n  margin: auto 0px;\n}\n\n.dashboard-layout-profile-category:hover {\n  cursor: pointer;\n}\n\n.dashboard-layout-profile-category::first-letter {\n  text-transform: uppercase;\n}\n\n.dashboard-layout-profile-category.Platinum {\n  background-image: linear-gradient(90deg, #353535 0%, #6b6962 100%);\n  color: white;\n}\n\n.dashboard-layout-profile-category.Gold {\n  background-image: linear-gradient(90deg, #d7980a 0%, #fcc201 100%);\n}\n\n.dashboard-layout-profile-category.Silver {\n  background-image: linear-gradient(90deg, #062360 0%, #2775ca 100%);\n  color: white;\n}\n\n.dashboard-layout-profile-category.Free {\n  background-image: linear-gradient(90deg, #003d3d 0%, #009898 100%);\n  color: white;\n}\n\n.dashboard-layout-content {\n  display: flex;\n  height: calc(100vh - 96px);\n}\n\n.dashboard-layout-sidemenu {\n  width: 215px;\n  padding: 24px 20px 0px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* .dashboard-layout-sidemenu-portfolio {\n    width: 183px;\n    height: 108px;\n    border-radius: 11.6px;\n    background-color: var(--primary-color-b);\n    padding: 12px 16px 12px 16px;\n    color: var(--primary-bg-color);\n  }\n  \n  .dashboard-layout-sidemenu-portfolio-label {\n    font-weight: 500;\n  }\n  \n  .dashboard-layout-sidemenu-portfolio-price {\n    font-weight: 700;\n  }\n  \n  .dashboard-layout-sidemenu-portfolio-turnover {\n    display: flex;\n    gap: 4px;\n    color: var(--semantic-success-color);\n    font-weight: 700;\n  }\n  \n  .dashboard-layout-sidemenu-portfolio-turnover-arrow {\n    font-size: 24px;\n    line-height: 40px;\n  } */\n\n.dashboard-layout-sidemenu-item {\n  width: 183px;\n  background-color: var(--other-shade-c-2);\n  padding: 18px 16px;\n  border-radius: 8px;\n  display: flex;\n  gap: 12px;\n}\n\n.selected-item {\n  background-color: var(--secondary-color-b);\n  color: var(--primary-bg-color);\n}\n\n.dashboard-layout-sidemenu-item-context {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.dashboard-layout-sidemenu-item-icon {\n  width: 24px;\n  height: 24px;\n  font-size: 24px;\n}\n\n.dashboard-layout-sidemenu-item-label {\n  line-height: 21px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.dashboard-layout-dropdown-backdrop {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1;\n}\n\n.dashboard-layout-dropdown {\n  position: absolute;\n  right: 150px;\n  top: calc(59px + 18px);\n  background-color: var(--primary-bg-color);\n  border-radius: 12px;\n  box-shadow: 4px 16px 64px 0px rgba(6, 35, 96, 0.2);\n  z-index: 2;\n  overflow: hidden;\n}\n\n.dashboard-layout-dropdown-item {\n  padding: 12px;\n  cursor: pointer;\n  width: 201px;\n}\n\n.dashboard-layout-dropdown-item.account {\n  box-shadow: inset 0px -2px 0px var(--neutral-color-a-0-5);\n}\n\n.dashboard-layout-dropdown-item.logout {\n  font-weight: 600;\n  color: var(--semantic-error-color);\n}\n\n.dashboard-layout-dropdown-item:active {\n  background-color: var(--neutral-color-a-0-5);\n}\n\n.checkbox {\n  opacity: 0;\n  position: absolute;\n}\n\n.checkbox-label {\n  background-color: #7c7c7c;\n  width: 40px;\n  height: 18px;\n  border-radius: 50px;\n  position: relative;\n  padding: 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.fa-moon {\n  color: #f1c40f;\n}\n\n.fa-sun {\n  color: #f39c12;\n}\n\n.checkbox-label .ball {\n  background-color: #fff;\n  width: 22px;\n  height: 22px;\n  position: absolute;\n  left: 2px;\n  top: 3px;\n  border-radius: 50%;\n  transition: transform 0.2s linear;\n}\n\n.checkbox:checked+.checkbox-label .ball {\n  transform: translateX(24px);\n}\n\n.checkbox-container {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  padding-top: 10px;\n}\n\n.home-page {\n  overflow: auto;\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 20px;\n  margin-left: 10px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 20px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #000000;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(14px);\n}\n\n/* Responsive styles for TV Chart page */\n@media (max-width: 1310px) {\n  .dashboard-layout-ribbon-logo {\n    width: 100px;\n    height: 30px;\n  }\n  \n  .dashboard-layout-ribbon-logo-athena {\n    width: 100px;\n    height: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-layout-ribbon {\n    padding: 5px 16px;\n    flex-wrap: wrap;\n    height: auto;\n    min-height: 60px;\n  }\n\n  .dashboard-layout-ribbon-logo {\n    width: 80px;\n    height: 25px;\n  }\n  \n  .dashboard-layout-ribbon-logo-athena {\n    width: 80px;\n    height: 25px;\n  }\n\n  .dashboard-layout-ribbon-logos {\n    gap: 8px;\n  }\n\n  .dashboard-layout-ribbon-profile-details {\n    gap: 8px;\n    flex-wrap: wrap;\n  }\n\n  .dashboard-layout-profile-image {\n    width: 36px;\n    height: 36px;\n  }\n\n  .dashboard-layout-profile-name {\n    font-size: 14px;\n  }\n\n  .dashboard-layout-profile-category {\n    font-size: 10px;\n    padding: 3px 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-layout-ribbon {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n    height: auto;\n    padding: 12px 16px;\n  }\n\n  .dashboard-layout-ribbon-logo {\n    width: 70px;\n    height: 20px;\n  }\n  \n  .dashboard-layout-ribbon-logo-athena {\n    width: 70px;\n    height: 20px;\n  }\n\n  .dashboard-layout-ribbon-logos {\n    gap: 6px;\n  }\n\n  .dashboard-layout-ribbon-profile-details {\n    width: 100%;\n    justify-content: space-between;\n    gap: 6px;\n  }\n\n  .dashboard-layout-profile-image {\n    width: 32px;\n    height: 32px;\n  }\n\n  .dashboard-layout-profile-name {\n    font-size: 12px;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .dashboard-layout-profile-category {\n    font-size: 9px;\n    padding: 2px 4px;\n    min-width: fit-content;\n  }\n\n  .checkbox-container {\n    padding-top: 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
